(() => {
  class SofaSteps extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this.ready || !this.isConnected) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-sofa-data]').textContent);
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.price = document.getElementById(`price-${this.dataset.section}`);
      this.sizes = Array.from(this.querySelectorAll('[data-size-group] input'));
      this.functions = Array.from(this.querySelectorAll('[data-function-group] input'));
      this.functionGroup = this.querySelector('[data-function-group]');
      this.colorGroup = this.querySelector('[data-color-group]');
      this.note = this.querySelector('[data-function-note]');
      this.summary = this.querySelector('[data-summary]');
      this.summaryFields = Object.fromEntries(['size', 'function', 'color', 'price'].map(key => [key, this.summary.querySelector(`[data-summary-${key}]`)]));
      this.sizeDisplay = this.info.querySelector('#variant-size-cm-display');
      if (this.sizeDisplay) this.querySelector('[data-size-display]').append(this.sizeDisplay);
      const factory = this.info.querySelector('.im-factory-spec');
      const custom = this.querySelector('[data-custom-details]');
      if (factory) {
        custom.append(factory);
        factory.open = true;
      }
      this.querySelector('.im-sofa-custom-toggle').addEventListener('click', event => {
        custom.hidden = !custom.hidden;
        event.currentTarget.setAttribute('aria-expanded', String(!custom.hidden));
      });
      const colors = this.info.querySelector('.grade-associated-colors-wrapper');
      if (colors) this.querySelector('[data-color-slot]').append(colors);
      this.form.before(this.summary);
      this.sizes.sort((a, b) => parseFloat(a.value) - parseFloat(b.value)).forEach(input => {
        this.querySelector('.im-sofa-sizes').append(input.parentElement);
      });
      this.addEventListener('change', event => {
        if (this.sizes.includes(event.target) || this.functions.includes(event.target)) this.sync(true);
      });
      this.colorListener = event => {
        if (event.detail?.section === this.dataset.section) this.updateSummary();
      };
      document.addEventListener('im:sofa-color', this.colorListener);
      this.form.addEventListener('submit', event => {
        if (!this.variant?.available || this.form.querySelector('[name="id"]').value !== String(this.variant.id)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          (this.sizes.find(input => input.checked) ? this.functions.find(input => !input.disabled) : this.sizes[0])?.focus();
        }
      }, true);
      const initial = this.data.variants.find(variant => variant.id === this.data.initialId);
      if (initial) {
        this.sizes.forEach(input => { input.checked = input.value === initial.options[0]; });
        this.functions.forEach(input => { input.checked = input.value === initial.options[2]; });
      }
      this.sync(false);
    }

    sync(updateURL) {
      const width = this.sizes.find(input => input.checked)?.value;
      const previousFunction = this.functions.find(input => input.checked)?.value;
      const candidates = this.data.variants.filter(variant => variant.options[0] === width);
      const allowed = new Set(candidates.map(variant => variant.options[2]));
      const reselect = !!previousFunction && !allowed.has(previousFunction);
      this.functionGroup.hidden = !width;
      this.functions.forEach(input => {
        const variant = candidates.find(item => item.options[2] === input.value);
        const card = input.parentElement;
        card.hidden = !variant;
        input.disabled = !variant || !variant.available;
        if (!variant) input.checked = false;
        card.toggleAttribute('data-included', allowed.size === 1);
        if (variant) {
          card.querySelector('[data-function-price]').textContent = this.data.display[variant.id].price + (variant.available ? '' : ` · ${this.data.text.soldOut}`);
          if (allowed.size === 1) input.checked = true;
        }
        input.hidden = !!variant && allowed.size === 1;
      });
      this.note.textContent = allowed.size === 1 ? this.data.text.included : reselect ? this.data.text.chooseAgain : this.data.text.chooseFunction;
      const feature = this.functions.find(input => input.checked)?.value;
      this.variant = candidates.find(variant => variant.options[2] === feature);
      this.note.hidden = allowed.size > 1 && !!this.variant;
      const display = this.variant && this.data.display[this.variant.id];
      const sizeCandidate = this.variant || candidates[0];
      if (this.sizeDisplay) {
        this.sizeDisplay.hidden = !sizeCandidate;
        this.sizeDisplay.style.display = sizeCandidate ? '' : 'none';
        this.sizeDisplay.textContent = sizeCandidate ? this.data.text.sizeLabel + this.data.display[sizeCandidate.id].size : '';
      }
      const idInput = this.form.querySelector('[name="id"]');
      idInput.value = this.variant ? String(this.variant.id) : '';
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (display) {
        this.price.innerHTML = display.html;
        const media = this.variant.featured_media;
        if (media) {
          const item = this.info.closest('section')?.querySelector(`[data-media-id="${this.dataset.section}-${media.id}"]`);
          if (item && item.parentElement.firstElementChild !== item) item.parentElement.prepend(item);
        }
        const pickup = this.info.querySelector('pickup-availability');
        if (pickup?.fetchAvailability && this.variant.available) pickup.fetchAvailability(this.variant.id);
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: this.variant } }));
      } else {
        const cheapest = (candidates.length ? candidates : this.data.variants).reduce((a, b) => a.price < b.price ? a : b);
        const range = document.createElement('span');
        range.className = 'price price--large';
        range.textContent = `${this.data.text.from} ${this.data.display[cheapest.id].price}`;
        this.price.replaceChildren(range);
      }
      this.price.classList.remove('visibility-hidden');
      this.colorGroup.hidden = !this.variant;
      const button = this.form.querySelector('[name="add"]');
      button.disabled = !this.variant?.available;
      button.querySelector('span').textContent = this.variant ? this.variant.available ? this.data.text.add : this.data.text.soldOut : width ? this.data.text.chooseFunction : this.data.text.chooseSize;
      const dynamic = this.form.querySelector('.dynamic-checkout-wrapper');
      if (dynamic) dynamic.hidden = !this.variant?.available;
      if (updateURL) {
        const url = new URL(window.location.href);
        if (this.variant) url.searchParams.set('variant', this.variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
      this.updateSummary();
    }

    updateSummary() {
      this.summary.hidden = !this.variant;
      if (!this.variant) return;
      const color = this.info.querySelector('.color-picker__value');
      const selected = this.functions.find(input => input.checked);
      this.summaryFields.size.textContent = this.data.display[this.variant.id].size;
      this.summaryFields.function.textContent = selected.parentElement.querySelector('[data-function-title]').textContent;
      this.summaryFields.color.textContent = color?.disabled ? '' : color?.value || '';
      this.summaryFields.price.textContent = this.data.display[this.variant.id].price;
    }

    disconnectedCallback() {
      document.removeEventListener('im:sofa-color', this.colorListener);
    }
  }
  if (!customElements.get('im-sofa-steps')) customElements.define('im-sofa-steps', SofaSteps);
})();
